import { OfficerTypeEnum } from '@generated/graphql';
import { OfficerCorporateForm } from './officer-corporate-form.class';
import { OfficerIndividualForm } from './officer-individual-form.class';
import { OfficerAuditorForm } from '@shared/classes/officer/officer-auditor-form.class';

export const officerFormFactories = {
  [OfficerTypeEnum.Individual]: () => new OfficerIndividualForm(),
  [OfficerTypeEnum.Secretary]: () => new OfficerIndividualForm(),
  [OfficerTypeEnum.Corporate]: () => new OfficerCorporateForm(),
  [OfficerTypeEnum.Auditor]: () => new OfficerAuditorForm(),
} as const;

type OfficerFormFactories = typeof officerFormFactories;
type OfficerFormFactoryFn =
  OfficerFormFactories[keyof OfficerFormFactories];

export function createOfficerForm(
  type: OfficerTypeEnum,
): ReturnType<OfficerFormFactoryFn> {
  const createFormFn = officerFormFactories[type];

  if (!createFormFn) {
    throw Error('Wrong form type');
  }

  return createFormFn();
}
